if (!customElements.get('custom-video')) {
  class CustomVideo extends HTMLElement {
    constructor() {
      super()
      this.items = this.querySelectorAll('div');
      this.loadIframe()
    }

    loadIframe() {
      this.items.forEach(item => {
        item.addEventListener('click', (e) => {
          console.log(e.target);
          const currentState = this.dataset.state;
          if (currentState === "VIDEO") {
            return;
          }
          fireCustomGA4Event("start_custom_video");
          this.render(item);
          this.setAttribute("data-state", "VIDEO");
        });
      })
    }

    render(item) {
      this.querySelector('.custom-video__media')?.remove();
      const media = document.createElement('div');
      const id = this.extractVideoID(item.dataset.url);
      const height = item.clientHeight
      media.className = 'custom-video__media';
      media.innerHTML = `
        <iframe style="height:${height}px" class="custom-video__iframe" src="https://www.youtube.com/embed/${id}?autoplay=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
      item.append(media);
    }

    extractVideoID(url) {
      const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      return match ? match[1] : null;
    }
  }

  customElements.define('custom-video', CustomVideo);
}